import type { App } from 'vue'

import { VueQueryPlugin } from '@tanstack/vue-query'

import { queryClient } from './queryClient'

export const installQueryPlugin = (app: App): void => {
  app.use(VueQueryPlugin, { queryClient })
}
